import {_} from 'i18n'
import PropTypes from 'prop-types'
import React, {useState} from 'react'

const ShowMore = ({children}) => {
  const [showFullText, setShowFullText] = useState(false)

  if (!children) return null

  const text = typeof children === 'string' ? children : String(children)
  const words = text.split(/\s+/)
  const hasMoreText = words.length > 70
  const limitedText = words.slice(0, 70).join(' ')
  const toggleShowMore = () => {
    setShowFullText(!showFullText)
  }

  return (
    <>
      {!hasMoreText || showFullText ? text : `${limitedText}...`}
      {hasMoreText && (
        <>
          {' '}
          <a onClick={toggleShowMore}>
            <b>{showFullText ? _`Fechar` : _`Ver mais`}</b>
          </a>
        </>
      )}
    </>
  )
}

ShowMore.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ShowMore
